import React from "react";
import { animateScroll as scroll } from "react-scroll";
import {
  FooterContainer,
  FooterWrap,
  FooterLinksContainer,
  FooterLinkItems,
  FooterLinkTitle,
  FooterLink,
  SocialMedia,
  SocialMediaWrap,
  SocialLogo,
  WebsiteRights,
  SocialIcons,
  SocialIconLink,
  FooterItemContact,
  FooterItemIconContactPhone,
  FooterItemContactText,
  FooterItemIconContactMail,
} from "../Footer/FooterElements";

import { FaFacebook, FaInstagram, FaYoutube, FaTwitter } from "react-icons/fa";

const Footer = () => {
  const toggleHome = () => {
    scroll.scrollToTop();
  };
  return (
    <FooterContainer>
      <FooterWrap>
        <FooterLinksContainer>
          <FooterLinkItems>
            <FooterLinkTitle>Meniu</FooterLinkTitle>
            <FooterLink to="">Despre Noi</FooterLink>
            <FooterLink to="">Misiune</FooterLink>
            <FooterLink to="">Grupe</FooterLink>
            <FooterLink to="">Viziune</FooterLink>
            <FooterLink to="">Galerie</FooterLink>
          </FooterLinkItems>

          <FooterLinkItems>
            <FooterLinkTitle>Parteneri</FooterLinkTitle>
            <FooterLink to="">
              Familiile copiilor prin Proiectul educațional ”Împreună pentru
              copiii noștri”
            </FooterLink>
            <FooterLink to="">Postul de Poliție Cordun</FooterLink>
            <FooterLink to="">Primăria</FooterLink>
            <FooterLink to="">Dispensarul medical</FooterLink>
            <FooterLink to="">
              Biserica romano-catolică ”Adormirea Maicii Domnului” , Pildești
            </FooterLink>
            <FooterLink to="">
              Centrul de persoane vârstnice din Gherăești
            </FooterLink>
          </FooterLinkItems>

          <FooterLinkItems>
            <FooterLinkTitle>Contact</FooterLinkTitle>
            <FooterItemContact>
              <FooterItemIconContactPhone />
              <FooterItemContactText>0233748684</FooterItemContactText>
            </FooterItemContact>
            <FooterItemContact>
              <FooterItemIconContactMail />
              <FooterItemContactText>
                gradirozaven.pildesti@gmail.com{" "}
              </FooterItemContactText>
            </FooterItemContact>
          </FooterLinkItems>
        </FooterLinksContainer>
        <SocialMedia>
          <SocialMediaWrap>
            <SocialLogo to="" onClick={toggleHome}>
              Roza Venerini
            </SocialLogo>
            <WebsiteRights>
              &copy; {new Date().getFullYear()} Toate drepturile rezervate
            </WebsiteRights>
            <SocialIcons>
              <SocialIconLink href="/" target="_blank" aria-label="Facebok">
                <FaFacebook />
              </SocialIconLink>
              <SocialIconLink href="/" target="_blank" aria-label="Instagram">
                <FaInstagram />
              </SocialIconLink>
              <SocialIconLink href="/" target="_blank" aria-label="Youtube">
                <FaYoutube />
              </SocialIconLink>
              <SocialIconLink href="/" target="_blank" aria-label="Twitter">
                <FaTwitter />
              </SocialIconLink>
            </SocialIcons>
          </SocialMediaWrap>
        </SocialMedia>
      </FooterWrap>
    </FooterContainer>
  );
};

export default Footer;
